// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"120c061543cf8525fa8d","655":"0bca26175e5eeae14d5e"}[chunkId] + ".js";
};